import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('goaldetail', ['itemById'])
  },
  methods: {
    ...mapActions('goaldetail', ['fetchItem'])
  }
}
